import { render, staticRenderFns } from "./PrivacyWeb.vue?vue&type=template&id=3d502d39&scoped=true&"
import script from "./PrivacyWeb.vue?vue&type=script&lang=js&"
export * from "./PrivacyWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d502d39",
  null
  
)

export default component.exports